import Axios from 'axios'

const urlBase = '/AfectaCompras/'
const urlBaseQuantity = `${urlBase}Cantidad/`
const urlBaseImport = `${urlBase}Importe/`
const urlBaseStatus = `${urlBase}Estado/`

export const purchasesQuantityAffected = async (params) => {
	const response = await Axios.get(urlBaseQuantity, { params })
	return response.data
}

export const purchasesAffectedValidate = async (params) => {
	const response = await Axios.post(`${urlBaseQuantity}validar`, params)
	return response.data
}

export const purchasesAffectedSubCalculation = async (params) => {
	const response = await Axios.get(`${urlBaseQuantity}CalculoSubtotales`, {
		params
	})
	return response.data
}

export const purchasesAffectedValidatePricesApi = async (params) => {
	const response = await Axios.post(`${urlBaseQuantity}ValPrecio`, params)
	return response.data
}

export const purchasesAffectedConfirm = async (params) => {
	const response = await Axios.post(`${urlBaseQuantity}/confirmar`, params)
	return response.data
}

export const purchasesAffectedImport = async (params) => {
	const response = await Axios.get(urlBaseImport, { params })
	return response.data
}

export const purchasesAffectedImpValidate = async (params) => {
	const response = await Axios.post(`${urlBaseImport}Validar`, params)
	return response.data
}

export const purchasesValidateDate = async (params) => {
	const response = await Axios.post(`${urlBaseImport}Validar/Fechas`, params)
	return response.data
}

export const purchasesAffectedImportConfirm = async (params) => {
	const response = await Axios.post(`${urlBaseImport}Confirmar`, params)
	return response.data
}

export const purchasesAffectedState = async (params) => {
	const response = await Axios.get(urlBaseStatus, { params })
	return response.data
}

export const purchasesAffectedStateValidate = async (params) => {
	const response = await Axios.post(`${urlBaseStatus}Validar`, params)
	return response.data
}

export const purchasesAffectedStateConfirm = async (params) => {
	const response = await Axios.post(`${urlBaseStatus}Confirmar`, params)
	return response.data
}
